import { setToast, setToastAction, hideToast } from './actions';
import immerHandleActions from 'redux/utils/immerHandleActions';

const init = {
	active: false,
	error: false,
	label: '',
	actionType: '',
};

type draft = typeof init;
const reducers = {
	[setToast](draft: draft, action: setToastAction) {
		const { active = true, error, label, actionType } = action.payload;
		draft.active = active;
		draft.error = error;
		draft.label = label;
		draft.actionType = actionType;
		return draft;
	},
	[hideToast](draft: draft) {
		return {
			...draft,
			active: false,
		};
	},
};

export default immerHandleActions(reducers, init);
